import { render } from "./emptyCartSvg.vue?vue&type=template&id=791671dd&scoped=true"
import script from "./emptyCartSvg.vue?vue&type=script&lang=js"
export * from "./emptyCartSvg.vue?vue&type=script&lang=js"

import "./emptyCartSvg.vue?vue&type=style&index=0&id=791671dd&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Sebastian\\Desktop\\-taptasty-order\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-791671dd"]])

export default __exports__